import React from 'react';
import { Outlet } from 'react-router-dom';
import PermissionRoute from '@/lib/auth/PermissionRoute';
import { getAuthToken, authApi } from '@/lib/api/auth';

const ProtectedRoute: React.FC<{ children?: React.ReactElement }> = ({ children }) => {
  return (
    <PermissionRoute
      module="accounting"
      getAuthToken={getAuthToken}
      fetchUser={authApi.fetchUser}
      noAccessPath="/panel/no-access"
      loginPath="/login"
    >
      {children ?? <Outlet />}
    </PermissionRoute>
  );
};

export default ProtectedRoute;
